import { useState } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Textarea } from '@/components/ui/textarea';
import { useTranslation } from 'react-i18next';
import { Mail, Loader2 } from 'lucide-react';
import { toast } from 'sonner';
import api from '@/utils/api';

export const SuggestionsModal = ({ isOpen, onClose }) => {
  const { t } = useTranslation();
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [isSending, setIsSending] = useState(false);

  const handleSubmit = async () => {
    if (!message.trim()) {
      toast.error(t('messageRequired'));
      return;
    }

    setIsSending(true);
    try {
      await api.post('/suggestions/submit', {
        name: name || null,
        email: email || null,
        message: message
      });
      
      toast.success(t('suggestionSent'));
      toast.success(t('thankYouFeedback'));
      
      // Clear form
      setName('');
      setEmail('');
      setMessage('');
      
      setTimeout(() => onClose(), 1500);
    } catch (error) {
      console.error('Error sending suggestion:', error);
      toast.error('Error al enviar el mensaje');
    } finally {
      setIsSending(false);
    }
  };

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="max-w-lg">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <Mail className="w-6 h-6 text-[#8FBC8F]" />
            {t('suggestionBox')}
          </DialogTitle>
          <DialogDescription>
            {t('suggestionBoxDesc')}
          </DialogDescription>
        </DialogHeader>
        <div className="space-y-4">
          <div>
            <Label htmlFor="name">{t('yourName')}</Label>
            <Input
              id="name"
              data-testid="suggestion-name"
              placeholder="Juan Pérez"
              value={name}
              onChange={(e) => setName(e.target.value)}
            />
          </div>
          <div>
            <Label htmlFor="email">{t('yourEmail')}</Label>
            <Input
              id="email"
              data-testid="suggestion-email"
              type="email"
              placeholder="tu@email.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </div>
          <div>
            <Label htmlFor="message">{t('yourMessage')} *</Label>
            <Textarea
              id="message"
              data-testid="suggestion-message"
              placeholder={t('messagePlaceholder')}
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              rows={5}
            />
          </div>
          <div className="text-xs text-gray-500">
            Tus sugerencias serán enviadas a: <strong>allergenapp.mail@gmail.com</strong>
          </div>
          <Button
            onClick={handleSubmit}
            disabled={isSending}
            className="w-full bg-[#8FBC8F] hover:bg-[#7CAA7C]"
            data-testid="send-suggestion-btn"
          >
            {isSending ? (
              <Loader2 className="w-4 h-4 animate-spin mr-2" />
            ) : (
              <Mail className="w-4 h-4 mr-2" />
            )}
            {t('sendSuggestion')}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};